"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGlobalstate = exports.GlobalState = void 0;

var GlobalState = function () {
  function GlobalState(initialValue) {
    this.value = initialValue;
    this.subscribers = [];
  }

  GlobalState.prototype.getValue = function () {
    return this.value;
  };

  GlobalState.prototype.setValue = function (newState) {
    var _this = this;

    if (this.getValue() === newState) {
      // No new update
      return;
    }

    this.value = newState;
    this.subscribers.forEach(function (subscriber) {
      subscriber.sendUpdateSignal(_this.value);
    });
  };

  GlobalState.prototype.delete = function () {
    this.subscribers.forEach(function (subscriber) {
      subscriber.sendDeleteSignal();
    });
  };

  GlobalState.prototype.subscribe = function (itemToSubscribe) {
    if (this.subscribers.indexOf(itemToSubscribe) > -1) {
      // Already subscribed
      return;
    } // Subscribe a component to this global state


    this.subscribers.push(itemToSubscribe);
  };

  GlobalState.prototype.unsubscribe = function (itemToUnsubscribe) {
    this.subscribers = this.subscribers.filter(function (subscriber) {
      return subscriber !== itemToUnsubscribe;
    });
  };

  return GlobalState;
}();

exports.GlobalState = GlobalState;

function createGlobalstate(initialValue) {
  return new GlobalState(initialValue);
}

exports.createGlobalstate = createGlobalstate;